// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export function setupPageSpy() {
  const { VITE_PAGESPY_PROJECT, VITE_PAGESPY_TITLE, VITE_PAGESPY_GESTURE } = import.meta.env;

  if (VITE_PAGESPY_PROJECT && VITE_PAGESPY_TITLE) {
    window.$harbor = new DataHarborPlugin();
    window.$rrweb = new RRWebPlugin();

    [window.$harbor, window.$rrweb].forEach(p => {
      PageSpy.registerPlugin(p);
    });
    const gesture = VITE_PAGESPY_GESTURE;
    window.$pageSpy = new PageSpy({
      lang: 'zh',
      project: VITE_PAGESPY_PROJECT,
      useSecret: true,
      title: VITE_PAGESPY_TITLE,
      enableSSL: true,
      modal: {
        title: '问题反馈'
      },
      // eslint-disable-next-line no-eval
      gesture: gesture ? eval(gesture) : null
    });
  }
}
